<template>
<div class="chapter">
<div class="inner_page">
<h1 class="P_Heading_1" id="auto_bookmark_toc_2"><span>Wolf at First Sight</span></h1>
<p class="P_Normal"> </p>
<p class="P_Normal"> </p>
<p class="P_Norm-NoInd">By Rhys Ford</p>
<p class="P_Normal"> </p>
<p class="P_Normal" id="a__Hlk132716472">SFPD Lieutenant Joseph Zanetti has spent years protecting his city, and from the looks of St. Connal’s Pub and its bad-boy owner, Levi Keller, the place is a hotspot for trouble and violence. Joe’s problem? Levi is delectably hot, with secrets Joe can’t wait to dig into.</p>
<p class="P_Normal">As a Peacekeeper for paranormals, wolf shifter Levi doesn’t need the complication of a hot cop sniffing around his pub when he’s just sent his teen son off to summer camp. He’s busy brokering a peace agreement between two warring factions. When Joe stumbles into Levi’s world, both plunge into a situation neither one of them was ready for—falling in love.</p>
<p class="P_Norm-Cen"><span>To everyone who loves things that go bump in the night…</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0002.vue?8cc4c8e0